import React, { useState } from "react";
import Tabs from "../../components/_profile/Tabs/Tabs";
import Favorites from "../../containers/_profile/Favorites/Favorites";
import History from "../../containers/_profile/History/History";
import Intro from "../../containers/_profile/Intro/Intro";
import Public from "../../containers/_profile/Public/Public";
import Layout from "../../shared/Layout/Layout";
import styles from "./Profile.module.scss";

const Profile = () => {
  const [stage, setStage] = useState(0);
  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.subContainer}>
          <Intro />
          <Tabs stage={stage} setStage={setStage} />

          {stage === 0 ? (
            <Public />
          ) : stage === 2 ? (
            <Favorites />
          ) : stage === 3 ? (
            <History />
          ) : null}
        </div>
      </div>
    </Layout>
  );
};

export default Profile;
